var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21553"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21552",
    transform: "translate(2.667 6.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 19928",
    width: 15.373,
    height: 2.196,
    rx: 1.098,
    transform: "translate(3.294)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 19930",
    width: 15.373,
    height: 2.196,
    rx: 1.098,
    transform: "translate(3.294 4.392)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 19931",
    width: 15.373,
    height: 2.196,
    rx: 1.098,
    transform: "translate(3.294 8.784)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 19932",
    width: 2.196,
    height: 2.196,
    rx: 1.098,
    transform: "translate(0 8.784)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 19933",
    width: 2.196,
    height: 2.196,
    rx: 1.098,
    transform: "translate(0 4.392)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 19934",
    width: 2.196,
    height: 2.196,
    rx: 1.098,
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19851",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.124db7f3a905dae3f637c1b1370ac2a1.svg";
export { ForwardRef as ReactComponent };